import { DefaultTopNavLayout } from "components/layout";
import React, { ReactElement } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getRouteLocalizationNamespaces } from "../../methods/getRouteLocalizationNamespaces";

import WhyChooseUs from "../../components/service-pages/why-choose-us/WhyChooseUs";
import { getWhyChooseUsPageLayout } from "components/service-pages/constants/company-pages-methods";

export default function WhyChooseusWeb() {
    return <WhyChooseUs />;
}

WhyChooseusWeb.getLayout = getWhyChooseUsPageLayout;

export async function getStaticProps({ locale }: any) {
    return {
        props: {
            isMobile: true,
            ...(await serverSideTranslations(locale, getRouteLocalizationNamespaces("whyChooseUs")))
        }
    };
}
